import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import { I18nextProvider } from 'react-i18next';

import ErrorBoundary from './component/ErrorBoundary';

import i18n from './i18n';
import './custom.css';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

ReactDOM.render(
    <ErrorBoundary>
        <Provider store={store}>
            <I18nextProvider i18n={i18n}>
                <ConnectedRouter history={history}>
                    <App />
                </ConnectedRouter>
            </I18nextProvider>
        </Provider>
    </ErrorBoundary>,
    document.getElementById('root'));

unregister();
// registerServiceWorker();
